import React, { useEffect, useState } from "react";
import QuestionsPage from "./QuestionsPage";
import ETriageLanding from "./Landing";
import ResultPage from "./Result/ResultPage";
import { save, load, getSurveyByClientId } from "../../api/survey";
import { useParams } from "react-router-dom";
import { async } from "regenerator-runtime";

const displaySection = {
  LANDING: "LANDING",
  QUESTIONS: "QUESTIONS",
  RESULT: "RESULT",
};

function ETriagePage() {
  let params = useParams();
  const [displayPage, setDisplayPage] = useState(displaySection.LANDING);
  const [answers, setAnswers] = useState([]);
  const [surveyKey, setSurveyKey] = useState("");
  const [clientId, setClientId] = useState("");
  const [clientPolicyData, setClientPolicyData] = useState({});
  const [isCustomer, setIsCustomer] = useState(false);
  const [referralKey, setReferralKey] = useState("");

  console.log(`process.env.REACT_APP_BU ${process.env.REACT_APP_BU}`);
  console.log(`process.env.env ${process.env.REACT_APP_ENV}`);
  async function fetchAnswer() {
    const answersLoaded = await load(params.surveyId);
    setAnswers(answersLoaded.answers);
    if (clientId == '') { setClientId(answersLoaded.clientId) }
    setDisplayPage(displaySection.RESULT);
  }
  useEffect(() => {
    if (!params.surveyId) {
      setAnswers([]);
      setDisplayPage(displaySection.LANDING);
    }

    if (params.surveyId && answers.length == 0) {
      fetchAnswer();
      setSurveyKey(params.surveyId);
    }

    if (params.referralKey) {
      setReferralKey(params.referralKey);
    }
    return;
  }, [params]);

  return (
    <>
      {displayPage === displaySection.LANDING ? (
        <ETriageLanding
          changePage={async (clientId, isCustomer, policyData) => {
            setIsCustomer(isCustomer);
            //Check if last survey exist
            if (clientId != "") {
              setClientPolicyData(policyData);
              await getSurveyByClientId(clientId)
                .then((response) => {
                  const lastSurvey = response;
                  if (lastSurvey) {
                    setSurveyKey(lastSurvey.surveyKey);
                    setAnswers(
                      lastSurvey.answers.map((answersItem) => {
                        return JSON.parse(answersItem).answer;
                      })
                    );
                    setClientId(clientId);
                    setDisplayPage(displaySection.RESULT);
                  } else {
                    console.log(clientId);
                    setClientId(clientId);
                    setDisplayPage(displaySection.QUESTIONS);
                  }
                })
                .catch((err) => {
                  console.log(clientId);
                  setClientId(clientId);
                  setDisplayPage(displaySection.QUESTIONS);
                });
            } else {
              console.log(clientId);
              setClientId(clientId);
              setDisplayPage(displaySection.QUESTIONS);
            }

            document
              .getElementById("root")
              .scrollTo({ top: 0, left: 0, behavior: "smooth" });
          }}
        />
      ) : displayPage === displaySection.QUESTIONS ? (
        <QuestionsPage
          changePage={async (answer) => {
            setDisplayPage(displaySection.RESULT);
            setAnswers(answer);
            setSurveyKey(await save(answer, clientId, isCustomer, clientPolicyData));
            document
              .getElementById("root")
              .scrollTo({ top: 0, left: 0, behavior: "smooth" });
          }}
        />
      ) : displayPage === displaySection.RESULT ? (
        <ResultPage
          clientId={clientId}
          answers={answers}
          surveyKey={surveyKey}
          retakeTest={() => {
            setAnswers([]);
            setSurveyKey("");
            setDisplayPage(displaySection.QUESTIONS);
            window.history.pushState(null, "", "/eTriage");
          }}
        />
      ) : null}
    </>
  );
}

export default ETriagePage;
